import React, { useRef } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import classnames from "classnames/bind";

import OuterClickListener from "@components/outer-click-listener";

import ActionButton from "../ActionButton";

import NotificationsList from "./components/NotificationsList";

import { useStore } from "../../connect";

import strings from "../../locales/strings";

import styles from "./NotificationButton.scss";

const cx = classnames.bind(styles);

const NotificationButton = ({
  mobile,
  isSmall,
  notificationsNumber,
  hideTooltip,
}) => {
  const { notifications } = useStore();
  const buttonRef = useRef(null);
  const containerRef = useRef(null);

  const handleNotificationButtonClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    notifications.setShowNotificationDropdown(
      !notifications.showNotificationDropdown
    );
  };

  const outsideClickHandler = (event) => {
    event.stopPropagation();

    notifications.setShowNotificationDropdown(false);
  };

  return (
    <div ref={containerRef} className={cx("notifications-button-container")}>
      <ActionButton
        tooltipText={strings.notifications}
        active={notifications.showNotificationDropdown}
        isSmall={isSmall}
        iconName="ic_notification"
        counter={notificationsNumber}
        onClick={handleNotificationButtonClick}
        ref={buttonRef}
        hideTooltip={hideTooltip}
      />
      {notifications.showNotificationDropdown && (
        <OuterClickListener
          className={cx("notifications-dropdown")}
          onClickOutside={outsideClickHandler}
        >
          <NotificationsList mobile={mobile} notificationSubmenu={isSmall} />
        </OuterClickListener>
      )}
    </div>
  );
};

NotificationButton.propTypes = {
  isSmall: PropTypes.bool,
  mobile: PropTypes.bool,
  // если убрать этот проп, то отвалится работа звука,
  // так как логика завязана на отслеживание изменений этой переменной
  notificationsNumber: PropTypes.number,
  hideTooltip: PropTypes.bool,
};

export default observer(NotificationButton);
